import React from 'react'
import PropTypes from 'prop-types'
import { Label, Table, Loader } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { CRUDIndex } from '../CRUD'
import { EditDeleteButtonContainer } from '../../containers'

const FonteComercializadora = (props) => (
  <CRUDIndex noTitle padded={false}
    onRedirectToNew={props.onRedirectToNew}
    onExportToCSV={props.onExportToCSV}
    filterText={props.filterText}
    handleFilter={props.handleFilter}
  >
    <Table sortable celled striped selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell textAlign='center' width={1}
            onClick={props.handleSort('id')}
            sorted={props.handleSorted('id')}>#</Table.HeaderCell>
          <Table.HeaderCell
            onClick={props.handleSort('fonte_energia.nome')}
            sorted={props.handleSorted('fonte_energia.nome')}>Fonte de Energia</Table.HeaderCell>
          <Table.HeaderCell width={4}
            onClick={props.handleSort('codigo_ccee')}
            sorted={props.handleSorted('codigo_ccee')}>Código CCEE</Table.HeaderCell>
          <Table.HeaderCell width={1}></Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {props.isLoading && (
          <Table.Row>
            <Table.Cell colSpan='4'>
              <Loader active={props.isLoading} inline='centered' />
            </Table.Cell>
          </Table.Row>
        )}
        {props.multipleFonteComercializadora.valueSeq().map((fonteComercializadora, index) => (
          <Table.Row key={index}>
            <Table.Cell textAlign='center'>
              <Label as={Link} to={`/comercializadoras/${fonteComercializadora.getIn(['comercializadora', 'id'])}/fontes_comercializadoras/${fonteComercializadora.get('id')}`}>{fonteComercializadora.get('id')}</Label>
            </Table.Cell>
            <Table.Cell>
              <Label as={Link} to={`/fontes_energia/${fonteComercializadora.getIn(['fonte_energia', 'id'])}`}>
                {fonteComercializadora.getIn(['fonte_energia', 'nome'])}
              </Label>
            </Table.Cell>
            <Table.Cell>{fonteComercializadora.get('codigo_ccee')}</Table.Cell>
            <Table.Cell>
              <EditDeleteButtonContainer
                onEditResource={() => props.onEditResource(props.comercializadora.id, fonteComercializadora.get('id'))}
                onDeleteResource={() => props.onDeleteResource(fonteComercializadora.get('id'))} />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  </CRUDIndex>
)

FonteComercializadora.propTypes = {
  comercializadora: PropTypes.object,
  multipleFonteComercializadora: PropTypes.object,
  onRedirectToNew: PropTypes.func,
  onEditResource: PropTypes.func,
  onDeleteResource: PropTypes.func,
  handleSort: PropTypes.func,
  handleSorted: PropTypes.func,
  filterText: PropTypes.string,
  handleFilter: PropTypes.func,
  onExportToCSV: PropTypes.func,
  isLoading: PropTypes.bool,
}

export default FonteComercializadora
